import { createApiActions } from '../../../helpers/actions';

import { User } from 'src/components/modules/usersList/types';

export const getUsers = createApiActions()(
  'users/getUsers',
  'users/getUsersSuccess',
  'users/getUsersError',
  (page: number, searchText: string) => ({ page, searchText })
);

export const editUser = createApiActions()(
  'users/editUser',
  'users/editUserSuccess',
  'users/editUserError',
  (userId: number, data: User) => ({ userId, data })
);
